import { IconClock, IconTruck } from "@tine/designsystem-icons/sharp";
import { cn } from "@tine/designsystem-utils";
import isNil from "lodash-es/isNil";
import { observer } from "mobx-react-lite";
import type { ReactNode } from "react";
import { logger } from "../../common/logger";
import { translateDayLabel } from "../../common/utils";
import { isLoading } from "../../common/utils/asyncDataUtils";
import { formatDeliveryDate } from "../../common/utils/dateUtils";
import Button from "../../components/Button";
import MainColumn from "../../components/common/MainColumn";
import DeliveryDateButton from "../../components/deliverydates/DeliveryDateButton";
import Loading from "../../components/Loading";
import authStore from "../../stores/auth/authStore";
import cartStore from "../../stores/cart/cartStore";
import deliveryDatesStore from "../../stores/deliveryDates/deliveryDatesStore";
import ChangeOrderOrSubscription from "../ChangeOrderOrSubscription";
import Deadline from "./Deadline";

const className = cn(["flex flex-row justify-start gap-8 py-2"]);

const itemClassName = cn(["flex flex-row items-center gap-2"]);

const iconAndLabelClassName = cn(["flex items-center", "font-bold"]);

const DeliveryInfo = () => {
   if (!authStore.isLoggedIn() || authStore.error) {
      return null;
   }

   if (isLoading(deliveryDatesStore.deliveryDates)) {
      return <Loading label="Laster leveringsdager..." />;
   }

   if (cartStore.isEditing() && !isNil(cartStore.editing)) {
      return <ChangeOrderOrSubscription />;
   }

   const dayLabel = translateDayLabel(cartStore.orderType);
   const currentDelivery = deliveryDatesStore.getCurrentDelivery();
   if (currentDelivery === null) {
      logger.log("delivery", "No current delivery found");
      return null;
   }

   const renderDeliveryDateButton: (dates: Date[], isPickerOpen: boolean, setPickerOpen: (show: boolean) => void) => ReactNode = (
      _dates,
      isPickerOpen,
      setPickerOpen
   ) => {
      return (
         <Button variant="tertiary" onClick={() => setPickerOpen(!isPickerOpen)}>
            Endre
         </Button>
      );
   };

   return (
      <MainColumn className="shadow-md bg-surface-default">
         <div className={className}>
            <div className={itemClassName}>
               <div className={iconAndLabelClassName}>
                  <IconClock className="mr-2" /> <p className="m-0 p-0">Frist:</p>
               </div>
               {!!currentDelivery.deadline && <Deadline />}
            </div>
            <div className={itemClassName}>
               <div className={iconAndLabelClassName}>
                  <IconTruck className="mr-2" />
                  <p className="m-0 p-0">{dayLabel}:</p>
               </div>
               <div className="flex items-center">
                  <div>{formatDeliveryDate(currentDelivery.date, cartStore.orderType, currentDelivery.interval)} |</div>
                  <DeliveryDateButton render={renderDeliveryDateButton} />
               </div>
            </div>
         </div>
      </MainColumn>
   );
};

export default observer(DeliveryInfo);
